<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">Slaves Become Cowboys</a></p>
<p class="toc"><a href="#/Chapter2#C2">Early Trail Drives</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">Goodnight and Loving Make Plans</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">Goodnight and Loving Blaze a Trail</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Tragedy Strikes in 1867</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">The Goodnight-Loving Trail Brings Cattlemen West</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Preparing for a Cattle Drive</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">Long Days on the Trail</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">Dangers of the Cattle Drive</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">Stampede!</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">Cookie Rules</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">The Trail Drive Ends in Town</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">Life on the Ranch</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">A Trusted Friend and Right-Hand Man</span></p>
<p class="toc2"><span href="#/Chapter14#C14-1" title="Link target outside of Sample">Shanghai Pierce and Neptune Holmes</span></p>
<p class="toc2"><span href="#/Chapter14#C14-2" title="Link target outside of Sample">Print Olive and Jim Kelly</span></p>
<p class="toc2"><span href="#/Chapter14#C14-3" title="Link target outside of Sample">John Chisum and Frank Chisum</span></p>
<p class="toc2"><span href="#/Chapter14#C14-4" title="Link target outside of Sample">John Slaughter and John Hinnaut, John Swain and Jim Young</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">Success Stories</span></p>
<p class="toc2"><span href="#/Chapter15#C15-1" title="Link target outside of Sample">George McJunkin</span></p>
<p class="toc2"><span href="#/Chapter15#C15-2" title="Link target outside of Sample">Nat Love</span></p>
<p class="toc2"><span href="#/Chapter15#C15-3" title="Link target outside of Sample">Bones Hooks</span></p>
<p class="toc2"><span href="#/Chapter15#C15-4" title="Link target outside of Sample">John Ware</span></p>
<p class="toc2"><span href="#/Chapter15#C15-5" title="Link target outside of Sample">Daniel Webster Wallace</span></p>
<p class="toc2"><span href="#/Chapter15#C15-6" title="Link target outside of Sample">Addison Jones</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1e30e027